import Icon from '../Icon/Icon';

interface HelpProps {
	path: string;
}

export function Help(props: HelpProps) {
	const { path } = props;
	return (
		<a href={path} className="help-nav-bar" target="_blank" rel="noreferrer">
			<Icon name="help" useMaterialIcons />
		</a>
	);
}
